import { Styles } from "@mcleod/core";

export const ImageStyles = Styles.make("img", () => {
    return {
        imageBase: {
            fill: "currentcolor",
            height: "1.5em",
            width: "1.5em",
            userSelect: "none"
        },
        rotate: {
            animation: "rotation 4s infinite linear"
        }
    }
});
